var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"draws-container"},[_c('h5',{staticClass:"text-center"},[_vm._v(_vm._s(_vm._f("lang")('draw_tickets')))]),_vm._v(" "),_c('b-list-group',{staticClass:"draw-tickets"},_vm._l((_vm.tickets),function(ticket){return _c('item',{key:ticket.id,staticClass:"bg-dark",attrs:{"ticket":ticket}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }